import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Logo from "../../assets/images/logo.png";
import "react-toastify/dist/ReactToastify.css";

import {
  Error,
  LoginContain,
  LoginFooter,
  RequiredStar,
} from "../../style/Login/UserLogin";
import { InitMfaLogin } from "../../services/authServices";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleInputChanges = (e, setValue) => {
    const { value } = e.target;
    setValue(value);
  };

  const validateForm = () => {
    if (!userId.trim()) {
      setError("User ID is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);

      // Call InitMfaLogin directly
      const response = await InitMfaLogin({ userId });
      if (response.success) {
        // Navigate to SendOtp with the required data
        navigate("/send-otp", {
          state: {
            data: {
              userId: userId,
              emailId: response.emailId,
              phoneNumber: response.phoneNumber,
            },
          },
        });
      } 
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <LoginContain>
        <div className="LoginCard">
          <div className="LoginLogo">
            <img src={Logo} alt="logo"  loading="lazy" />
          </div>
          <div className="LoginTitle">
            <h4>User Login</h4>
            <p>Please login to your account.</p>
          </div>
          <form onSubmit={handleSubmit}>
            {/* User ID Input */}
            <div className="LoginGroup">
              <label htmlFor="userId">
                User ID <RequiredStar>*</RequiredStar>
              </label>
              <input
                type="text"
                id="userId"
                name="userId"
                value={userId}
                placeholder="Enter Your ID"
                onChange={(e) => handleInputChanges(e, setUserId)}
              />
              {error && <Error>{error}</Error>}
            </div>

            {/* Submit Button */}
            <div className="LoginGroup LoginBtn">
              <button type="submit" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>
          </form>
        </div>
      </LoginContain>

      {/* Footer Section */}
      <LoginFooter>
        <p>
          POWERED BY: <span>Manthan IT Solutions</span>
        </p>
      </LoginFooter>
    </>
  );
};

export default Login;
